import Icon from 'veui/components/Icon'

Icon.register({
  'flow-activate': {
    paths: [
      {
        d: 'M736 384a32 32 0 01-64 0 288 288 0 10-288 288 32 32 0 010 64A352.09 352.09 0 01247 59.67 351.9 351.9 0 01736 384zm-274.74 32H544a32 32 0 000-64H384a32 32 0 00-32 32v160a32 32 0 0064 0v-82.74l233.37 233.37a32 32 0 0045.26-45.26z'
      }
    ],
    width: '768',
    height: '768'
  }
})
